/*
    点击元素外部服务
    1、指令必须初始化渲染
    2、服务自治
 */
const elMap = new Map();

const _documentHandler = (e)=>{
  for (let [el, callback] of elMap) {
    !el.contains(e.target) && callback();
  }
};

const _initClick = (() =>{
  let init = false;
  return () =>{
    if (!init) {
      init = true;
      document.addEventListener(
        'click',
        _documentHandler,
      );
    }
  };
})();

export const onOutsideClick = (el, callback, immediate = true) =>{
  _initClick();
  if (!immediate) {
    setTimeout(() => {
      elMap.set(el, callback);
    });
  } else {
    elMap.set(el, callback);
  }
};

export const clearOutSideClick = (el)=>{
  elMap.delete(el);
};
